import { defineMessages } from 'react-intl';

export const i18n: {
	assignee: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraFilterAssigneeLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraFilterAssigneeLabelUnselected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	jiraFilterContributorPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	assignee: {
		id: 'dynamic-cards-search-page.filters.names.assignee',
		defaultMessage: 'Assignee',
		description:
			'Text shown as the heading label for the assignee filter on the search page, used to narrow Jira search results by the person assigned to an issue.',
	},
	jiraFilterContributorPlaceholder: {
		id: 'dynamic-cards-search-page.jira.filter.assignee.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for assignee filter search input',
	},
	jiraFilterAssigneeLabelSelected: {
		id: 'dynamic-cards-search-page.jira.filter.assignee.selected',
		defaultMessage: 'Selected',
		description:
			'Section heading label shown above the list of already-selected assignees in the Jira assignee filter drop-down on the search page.',
	},
	jiraFilterAssigneeLabelUnselected: {
		id: 'dynamic-cards-search-page.jira.filter.assignee.unselected',
		defaultMessage: 'Suggested',
		description:
			'Section heading label shown above the list of suggested assignees not yet selected in the Jira assignee filter drop-down on the search page.',
	},
});
